import 'jquery';
import 'bootstrap';
import 'bootstrap-datepicker';
import 'jquery-match-height';

(function($) {
    'use strict';

    $.fn.datepicker.dates['fr'] = {
        days: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
        daysShort: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
        daysMin: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
        /// daysMin: ["d", "l", "ma", "me", "j", "v", "s"],
        months: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
        monthsShort: ["janv.", "févr.", "mars", "avril", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
        today: "Aujourd'hui",
        monthsTitle: "Mois",
        clear: "Effacer",
        weekStart: 1,
        format: "dd/mm/yyyy"
    };

    window.mpam_equalizeNbrHoursElements = () => {
        const elements = [
            '.list-nbr-hours>.item-nbr-hour .option-info-name',
            '.list-nbr-hours>.item-nbr-hour .option-info-hours',
            '.list-nbr-hours>.item-nbr-hour .option-info-price',
            '.list-nbr-hours>.item-nbr-hour .option-radio',
            '.list-nbr-hours>.item-nbr-hour>label',
            '.list-nbr-hours>.item-nbr-hour'
        ];

        elements.forEach(el => {
            $(el).matchHeight({
                property: 'min-height'
            });
        });

        $('.item-nbr-hour:not(.initialized-resize)').addClass('initialized-resize');
    }

    window.mpam_process_prodct = {
        stepsEl: null,
    	step: 0,
    	is_test: false,
        product_options: {
            cours_code: null,
            cours_id: null,
            level_code: null,
            level_id: null,
            class_code: null,
            class_id: null,
            formule_code: null,
            formule_id: null,
            nbr_hours_code: null,
            nbr_hours_id: null,
            date_start: null,
            disponibility: null,
        },
        breadcrumb: [],
    	printBreadcrumb: function() {
            const breadcrumbEl = this.stepsEl.find('.breadcrumb-select-product');

            this.breadcrumb = this.breadcrumb.filter((el, index, self) =>
              index === self.findIndex((t) => (
                t.step === el.step
              ))
            );

            if (this.breadcrumb && this.breadcrumb.length) {
                breadcrumbEl.html("");
                const html_breadcrumn = $('<ul>');
                this.breadcrumb.forEach(step => {
                    html_breadcrumn.append('<li><span href="#" data-step="' + step.id + '" >' + step.title + '</span></li>');
                });
                breadcrumbEl.html(html_breadcrumn);
            } else {
                breadcrumbEl.html("");
            }
    	},
        backStep: function() {
            this.breadcrumb.pop();
            this.printBreadcrumb();
            this.goToStep(this.step - 1);
        },
        goToStep: function(step, html_content = null, stepData = null) {
        	if (this.is_test && step === 5) {
        		step = 3;
        	}

            this.step = step;

            if (step === 0) {
                this.breadcrumb = [];
            }

            if (stepData) {
                this.breadcrumb.push(stepData);
            }

            this.printBreadcrumb();

            this.stepsEl.find('.mpf-step').removeClass('active');

            if (html_content !== null) {
                this.stepsEl.find('[data-step-id="' + step + '"]').html(html_content);
            }

            this.stepsEl.find('[data-step-id="' + step + '"]').addClass('active');
            this.stepsEl.attr('data-active-step', step);

            if (step > 0) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: this.stepsEl.offset().top - 300 + $('.main-header').height()
                }, 500);
            }
        },
        showErrors: function(messages) {
            if (messages && messages.length) {
                messages.forEach(message => {
                    alert(message);
                });
            }
        },
        isLoading() {
            return this.stepsEl.hasClass('is-loading');
        },
        goSelectLevel: function() {
            var self = this;

            if (this.isLoading()) {return}

            self.stepsEl.addClass('is-loading');

            $.post(woocommerce_params.ajax_url, {
                action: 'mpam_ajax_get_levels',
                data: self.product_options,
            }, function(res) {
                self.stepsEl.removeClass('is-loading');

                if (res && res.success) {
                    self.goToStep(1, res.html_content);
                } else if (res.messages && res.messages.length) {
                    self.showErrors(res.messages);
                }
            }, 'json');
        },
        goSelectClass: function() {
            var self = this;

            if (this.isLoading()) {return}

            self.stepsEl.addClass('is-loading');

            $.post(woocommerce_params.ajax_url, {
                action: 'mpam_ajax_get_classes',
                data: self.product_options,
            }, function(res) {
                self.stepsEl.removeClass('is-loading');

                if (res && res.success) {
                    self.goToStep(2, res.html_content);
                } else if (res.messages && res.messages.length) {
                    self.showErrors(res.messages);
                }
            }, 'json');
        },
        goSelectFormule: function() {
            var self = this;

            if (this.isLoading()) {return}

            self.stepsEl.addClass('is-loading');

            $.post(woocommerce_params.ajax_url, {
                action: 'mpam_ajax_get_formules',
                data: self.product_options,
            }, function(res) {
                self.stepsEl.removeClass('is-loading');

                if (res && res.success) {
                    self.goToStep(3, res.html_content);
                } else if (res.messages && res.messages.length) {
                    self.showErrors(res.messages);
                }
            }, 'json');
        },
        goSelectNbrHours: function() {
            var self = this;

            if (this.isLoading()) {return}

            self.stepsEl.addClass('is-loading');

            $.post(woocommerce_params.ajax_url, {
                action: 'mpam_ajax_get_nbr_hours',
                data: self.product_options,
            }, function(res) {
                self.stepsEl.removeClass('is-loading');

                if (res && res.success) {
                    self.goToStep(4, res.html_content);
                    window.mpam_equalizeNbrHoursElements();
                } else if (res.messages && res.messages.length) {
                    self.showErrors(res.messages);
                }
            }, 'json');
        },
        goSelectCalendar: function() {
            var self = this;

            if (this.isLoading()) {return}

            self.stepsEl.addClass('is-loading');

            setTimeout(function() {
                self.stepsEl.removeClass('is-loading');
                self.goToStep(5);
            }, 1000);
        },
        goSubmit: function() {
            var self = this;

            if (this.isLoading()) {return}

            self.stepsEl.addClass('is-loading');

            $.post(woocommerce_params.ajax_url, {
                action: 'mpam_ajax_submit_product',
                data: self.product_options,
            }, function(res) {
                self.stepsEl.removeClass('is-loading');
                if (res && res.success && res.attrs && res.attrs.redirection_url) {
                    window.location = res.attrs.redirection_url;
                } else if (res.messages && res.messages.length) {
                    self.showErrors(res.messages);
                }
            }, 'json');
        },
    	init: function(selector) {
            var self = this;

    		self.stepsEl = $(selector);

    		self.is_test = !!(Number(self.stepsEl.attr('data-test-product')) === 1);
    		self.product_options.is_test = (self.is_test) ? 1 : 0;

    		self.step = 0;
    		self.stepsEl.find('.mpf-step').each(function (idx, stepEl) {
    			$(stepEl).attr('data-step-id', idx);
    		});

            $(document).on('click', '.btn-select-cours', function(e) {
                e.preventDefault();
                self.product_options.cours_id = $(this).attr('data-option-id');
                self.product_options.cours_code = $(this).attr('data-option-code');
                self.product_options.cours_label = $(this).attr('data-option-label');

                self.breadcrumb.push({
                    step: 'cours',
                    id: self.product_options.cours_id,
                    title: self.product_options.cours_label
                });

                self.goSelectLevel();
            });

            $(document).on('click', '.btn-select-level', function(e) {
                e.preventDefault();
                self.product_options.level_id = $(this).attr('data-option-id');
                self.product_options.level_code = $(this).attr('data-option-code');
                self.product_options.level_label = $(this).attr('data-option-label');

                self.breadcrumb.push({
                    step: 'level',
                    id: self.product_options.level_id,
                    title: self.product_options.level_label
                });

                self.goSelectClass();
            });

            $(document).on('click', '.btn-select-class', function(e) {
                e.preventDefault();
                self.product_options.class_id = $(this).attr('data-option-id');
                self.product_options.class_code = $(this).attr('data-option-code');
                self.product_options.class_label = $(this).attr('data-option-label');

                self.breadcrumb.push({
                    step: 'class',
                    id: self.product_options.class_id,
                    title: self.product_options.class_label
                });

                if (self.is_test) {
                	self.goSelectCalendar();
                } else {
                	self.goSelectFormule();
                }
            });

            $(document).on('click', '.btn-select-formule', function(e) {
                e.preventDefault();
                self.product_options.formule_id = $(this).attr('data-option-id');
                self.product_options.formule_code = $(this).attr('data-option-code');
                self.product_options.formule_label = $(this).attr('data-option-label');

                self.breadcrumb.push({
                    step: 'formule',
                    id: self.product_options.formule_id,
                    title: self.product_options.formule_label
                });

                self.goSelectNbrHours();
            });

            $(document).on('change', '[name="nbr_hour_option"]', function(e) {
                e.preventDefault();
                self.product_options.nbr_hours_id = $(this).attr('data-option-id');
                self.product_options.nbr_hours_code = $(this).attr('data-option-code');
                self.product_options.nbr_hours_label = $(this).attr('data-option-label');

                self.breadcrumb.push({
                    step: 'nbr_hours',
                    id: self.product_options.nbr_hours_id,
                    title: self.product_options.nbr_hours_label
                });

                // self.goSelectCalendar();
            });

            $(document).on('click', '.list-nbr-hours .item-nbr-hour label', function(e) {
                e.preventDefault();

                $('.list-nbr-hours').find('.item-nbr-hour').removeClass('selected');
                $('.list-nbr-hours').find('input[type="radio"]').prop('checked', false);

                $(this).find('input[type="radio"]').prop('checked', true);
                $(this).parent().addClass('selected');
                self.product_options.nbr_hours_id = $(this).parent().attr('data-option-id');
                self.product_options.nbr_hours_code = $(this).parent().attr('data-option-code');
                self.product_options.nbr_hours_label = $(this).parent().attr('data-option-label');

                self.breadcrumb.push({
                    step: 'nbr_hours',
                    id: self.product_options.nbr_hours_id,
                    title: self.product_options.nbr_hours_label
                });

                if (self.product_options.formule_code === 'stage') {
                    self.goSubmit();
                } else {
                    self.goSelectCalendar();
                }
            });

            $(document).on('click', '.btn-select-disponibility', function(e) {
                e.preventDefault();
                self.stepsEl.find('.btn-select-disponibility').removeClass('active');
                $(this).addClass('active');
                self.product_options.disponibility = $(this).attr('data-option-value');
            });

            $(document).on('click', '.btn-submit-calendar', function(e) {
                e.preventDefault();
                if (self.product_options.date_start === null || self.product_options.date_start === ''
                	|| self.product_options.disponibility === null || self.product_options.disponibility === '') {
                	self.stepsEl.find('.alert-calendar').removeClass('d-none');
                } else {
                	self.stepsEl.find('.alert-calendar').addClass('d-none');

                    self.breadcrumb.push({
                        step: 'date_disponiblity',
                        id: 'date_disponiblity',
                        title: self.product_options.date_start + ' ' + self.product_options.disponibility
                    });

                	self.goSubmit();
                }
            });

            $('#product_calendar_input').datepicker({
                language: 'fr',
                format: 'yyyy-mm-dd',
                startDate: "+1d",
                daysOfWeekDisabled: window.products_dates_disabled || '1,2,4,5',
            });

            $('#product_calendar_input').on('changeDate', function() {
                var selected_date_start = $('#product_calendar_input').datepicker('getFormattedDate');
                $('#product_calendar_date').val(selected_date_start);
                if ($('#product_calendar_input').datepicker('getDate').getDay() === 3) {
                	$('.btn-select-disponibility.is-am').prop('disabled', true);
                	$('.btn-select-disponibility.is-am').removeClass('active');
                	self.product_options.disponibility = null;
                } else {
                	$('.btn-select-disponibility.is-am').prop('disabled', false);
                }
                self.product_options.date_start = selected_date_start;
            });

            $(document).on('click', '.btn-back-step', function(e) {
                e.preventDefault();
                self.backStep();
            });

    		self.goToStep(0);
    	},
    }

    mpam_process_prodct.init("#mpf-steps");

}(jQuery));
